<ion-card>
  <ion-card-header>
    <div class="flex-container margin-bottom">
      <div class="left-column">
        <ion-title class="ion-no-padding">
          <ion-label class="title">{{ title | translate}}</ion-label>
        </ion-title>
      </div>
      <div class="right-column">
        <ion-button class="app-btn footer-btn" shape="round" fill="outline" size="medium" (click)="onCancel()">
          {{'Cancel' | translate }}
        </ion-button>
        <ion-button
          shape="round" fill="outline" color="primary" *ngIf="!showEdit" (click)="onUserAction()">
          <img src="../../../assets/icon/edit.svg" class="log-edit-img" alt="">
          {{'Edit'|translate}}
        </ion-button>
      </div>
    </div>
  </ion-card-header>
  <ion-card-content class="card-container scrollVertical">
    <ng-container *ngFor="let header of headers">
      <p class="header">{{ header.GroupHeaders | translate }}</p>
      <ion-row>
        <ng-container *ngFor="let value of values">
          <ion-col size="4" *ngIf="header.GroupHeaderID == value.GroupHeaderID">
            <ion-label>{{ value?.FieldName | translate}}</ion-label>
            <ion-row>{{ value?.FieldValue ? value?.FieldValue : 'NA' }}</ion-row>
          </ion-col>
        </ng-container>
      </ion-row>
    </ng-container>
  </ion-card-content>
</ion-card>